// User types
export const SET_USER = "SET_USER";
export const REMOVE_USER = "REMOVE_USER";
export const UPDATE_USER = "UPDATE_USER";
// Contract types
export const SET_LATEST_CONTRACT = "SET_LATEST_CONTRACT";
// Organisation types
export const SET_ORGANISATION = "SET_ORGANISATION";
export const SET_ORGANISATIONS = "SET_ORGANISATIONS";
export const SET_SELECTED_ORGANISATIONS = "SET_SELECTED_ORGANISATIONS";
export const LOADING_GET_ORGANISATIONS = "LOADING_GET_ORGANISATIONS";
// Users types
export const GET_USERS = "GET_USERS";
export const LOADING_GET_USERS = "LOADING_GET_USERS";
// Savings types
export const GET_SAVINGS = "GET_SAVINGS";
export const LOADING_GET_SAVINGS = "LOADING_GET_SAVINGS";
export const SET_SAVING = "SET_SAVING";
export const LOADING_UPDATE_SAVING = "LOADING_UPDATE_SAVING";
// Investments types
export const GET_INVESTMENTS = "GET_INVESTMENTS";
export const LOADING_GET_INVESTMENTS = "LOADING_GET_INVESTMENTS";
// Loans types
export const GET_LOANS = "GET_LOANS";
export const SET_LOAN = "SET_LOAN";
export const LOADING_GET_LOANS = "LOADING_GET_LOANS";
export const ERROR_GETTING_LOANS = "ERROR_GETTING_LOANS";
// Loans types
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const SET_TRANSACTION = "SET_TRANSACTION";
export const LOADING_GET_TRANSACTIONS = "LOADING_GET_TRANSACTIONS";
export const ERROR_GETTING_TRANSACTIONS = "ERROR_GETTING_TRANSACTIONS";
export const LOADING_UPDATE_TRANSACTION = "LOADING_UPDATE_TRANSACTION";
